/* eslint-disable */
import React, { useState, useEffect } from 'react';
import './styles/Header.css';
import './styles/Navbar.css';
import logo from '../../assets/images/moh.svg'

const Header = ({ currentPage, setCurrentPage }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 50); 
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="ministry-header">
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <span className="government-tag">Government of the Republic of South Sudan</span>
            <div className="top-bar-actions">
              <select className="language-selector">
                <option value="en">English</option>
                <option value="ar">Arabic</option>
              </select>
              <button className="emergency-alert">
                <span className="alert-icon">⚠</span>
                Emergency Alerts
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={`main-header ${isScrolled ? 'hidden' : ''}`}>
        <div className="container">
          <div className="header-content">
            <div className="logo-section">
              <div className="logo-wrapper">
                <img 
                  src={logo}
                  alt="Ministry of Health Logo" 
                  className="ministry-logo"
                />
                <div className="logo-badge">
                  <span>Republic of South Sudan</span>
                </div>
              </div>
              <div className="department-info">
                <h1 className="department-titles">
                  Ministry of Health
                </h1>
                <h2 className="department-subtitle">
                  Department of Health Security, SCD & One Health
                </h2>
                <p className="department-tagline">
                  Protecting Nation's Health Through Integrated One Health Approaches
                </p>
              </div>
            </div>

            <div className="header-actions">
              <button className="donate-btn">
                <span className="donate-icon">❤</span>
                Support Our Mission
              </button>
              <div className="search-box">
                <input type="text" placeholder="Search..." />
                <button className="search-btn">🔍</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav className={`ministry-nav ${isScrolled ? 'compact' : ''}`}>
        <div className="container">
          <div className="nav-content">
            {isScrolled && (
              <div className="compact-logo">
                <img 
                  src={logo}
                  alt="Ministry of Health" 
                  className="compact-logo-img"
                />
              </div>
            )}

            <button 
              className="mobile-menu-toggle"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            <ul className={`nav-menu ${isMobileMenuOpen ? 'nav-menu-open' : ''}`}>
              <li>
                <button 
                  onClick={() => {
                    setCurrentPage('home');
                    setIsMobileMenuOpen(false);
                  }}
                  className={currentPage === 'home' ? 'nav-item active' : 'nav-item'}
                >
                  <span className="nav-icon">🏠</span>
                  Home
                </button>
              </li>
              <li className="nav-dropdown">
                <button className="nav-item">
                  <span className="nav-icon">ℹ</span>
                  About Us
                  <span className="dropdown-arrow">▼</span>
                </button>
                <div className="dropdown-menu">
                  <button onClick={() => {
                    setCurrentPage('about');
                    setIsMobileMenuOpen(false);
                    setTimeout(() => {
                    document.getElementById('about-us')?.scrollIntoView({ behavior: 'smooth' });
                  }, 0);
                  }}>Overview</button>
                  <button 
                   onClick={() => {
                    setCurrentPage('about');
                    setIsMobileMenuOpen(false);
                    setTimeout(() => {
                      document.getElementById('leadership')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                  }}>Leadership</button>
                  <button 
                   onClick={() => {
                    setCurrentPage('about');
                    setIsMobileMenuOpen(false);
                    setTimeout(() => {
                      document.getElementById('Executive-leadership')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                  }}>Organizational Structure</button>
                  <button 
                   onClick={() => {
                    setCurrentPage('about');
                    setIsMobileMenuOpen(false);
                    setTimeout(() => {
                      document.getElementById('strategic-objectives')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                  }}>Strategic Objectives</button>
                </div>
              </li>
              <li>
                <button 
                  onClick={() => {
                    setCurrentPage('services');
                    setIsMobileMenuOpen(false);
                  }}
                  className={currentPage === 'services' ? 'nav-item active' : 'nav-item'}
                >
                  <span className="nav-icon">🛠</span>
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    setCurrentPage('news');
                    setIsMobileMenuOpen(false);
                  }}
                  className={currentPage === 'news' ? 'nav-item active' : 'nav-item'}
                >
                  <span className="nav-icon">📰</span>
                  News & Events
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    setCurrentPage('resources');
                    setIsMobileMenuOpen(false);
                  }}
                  className={currentPage === 'resources' ? 'nav-item active' : 'nav-item'}
                >
                  <span className="nav-icon">📚</span>
                  Resources
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    setCurrentPage('transparency');
                    setIsMobileMenuOpen(false);
                  }}
                  className={currentPage === 'transparency' ? 'nav-item active' : 'nav-item'}
                >
                  <span className="nav-icon">🔍</span>
                  Transparency
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    setCurrentPage('contact');
                    setIsMobileMenuOpen(false);
                  }}
                  className={currentPage === 'contact' ? 'nav-item active' : 'nav-item'}
                >
                  <span className="nav-icon">📞</span>
                  Contact
                </button>
              </li>
                            <li>
                <button 
                  onClick={() => {
                    setCurrentPage('gallery');
                    setIsMobileMenuOpen(false);
                  }}
                  className={currentPage === 'gallery' ? 'nav-item active' : 'nav-item'}
                >
                  <span className="nav-icon">📞</span>
                  gallery
                </button>
              </li>
            </ul>

            <div className="nav-utils">
              <button className="accessibility-btn" title="Accessibility Options">
                ♿
              </button>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;